import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, Accordion, AccordionItem, Collapse } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import classnames from "classnames";
import ModalImage from "react-modal-image";
import handleValidDate from "../../../helpers/utils/handleValidDate";

// Formik
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetBrandState, getBrand } from "../../../store/brand/action";
import { resetProductInventoryState, getProductInventory as onGetProductInventories, addNewProductInventory as onAddNewProductInventory, updateProductInventory as onUpdateProductInventory, deleteProductInventory as onDeleteProductInventory, getProductInventoryLoading } from "../../../store/productInventory/action";
import { resetProductInventoryBranchState, getProductInventoryBranch as onGetProductInventoryBranches, addNewProductInventoryBranch as onAddNewProductInventoryBranch, updateProductInventoryBranch as onUpdateProductInventoryBranch, getProductInventoryBranchLoading } from "../../../store/productInventoryBranch/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import defaultImg from "../../../assets/images/upload.png";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import lottie from "lottie-web";
import { defineElement } from "lord-icon-element";
import ExportDoc from "../../../Components/Common/ExportDoc";
defineElement(lottie.loadAnimation);

const ProductInventoryBranch = () => {
  const [pageIdx, setPageIdx] = useState(0);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, productInventoryBranches, productInventoryBranchAdded, isProductInventoryBranchCreated, isProductInventoryBranchSuccess, loading, error, companies, companyLoading, branches, branchLoading, productVarians, productVarianLoading, brands, brandLoading, productInventories, productInventoryLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    productInventoryLoading: state.ProductInventory.loading,
    productInventories: state.ProductInventory.productInventories,
    productInventoryBranchAdded: state.ProductInventoryBranch.productInventoryBranchAdded,
    productInventoryBranches: state.ProductInventoryBranch.productInventoryBranches,
    isProductInventoryBranchCreated: state.ProductInventoryBranch.isProductInventoryBranchCreated,
    isProductInventoryBranchSuccess: state.ProductInventoryBranch.isProductInventoryBranchSuccess,
    loading: state.ProductInventoryBranch.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    brands: state.Brand.brands,
    brandLoading: state.Brand.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.ProductInventoryBranch.error,
  }));

  const [productInventoryBranchList, setProductInventoryBranchList] = useState([]);
  const [productInventoryBranchDoc, setProductInventoryBranchDoc] = useState([]);
  const [productInventoryBranch, setProductInventoryBranch] = useState([]);
  const [info, setInfo] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [companyId, setCompanyId] = useState(0);
  const [branchList, setBranchList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [stockCard, setStockCard] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusProductInventoryBranch, setStatusProductInventoryBranch] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [productList, setProductList] = useState([]);
  const [productInventoryBranchDetailItem, setProductInventoryBranchDetailItem] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState("");

  const filerIdRef = useRef({
    branchId: 1,
  });
  const [searchBranch, setSearchBranch] = useState("");

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleActiveAccordion = (el) => {
    if (el !== activeAccordion) setActiveAccordion(el);
    else setActiveAccordion("");
  };

  useEffect(() => {
    if (!isEmpty(productInventories)) {
      let arr = [];
      let saldo = 0;
      productInventories.sort((a, b) => new Date(a.transactionat) - new Date(b.transactionat)).forEach(pi => {
        pi.inv_detail.forEach(data => {
          let inbound = pi.transaction_status === "IN" ? parseFloat(data.quantity) : 0;
          let outbond = pi.transaction_status === "OUT" ? parseFloat(data.quantity) : 0;
          if (inbound > 0) {
            saldo = saldo + inbound;
          }
          if (outbond > 0) {
            saldo = saldo - outbond;
          }
          let obj = data;
          let type = "-";
          let transactionat = pi.transactionat;
          let transaction_no = pi.transaction_no;
          if (pi.inv_sales) {
            type = "Sales";
            transactionat = pi.inv_sales.transactionat;
            transaction_no = pi.inv_sales.transaction_no;
          }

          if (pi.inv_purchase) {
            type = "Purchase";
            transactionat = pi.inv_purchase.transactionat;
            transaction_no = pi.inv_purchase.transaction_no;
          }

          obj.type = type;
          obj.transaction_status = pi.transaction_status;
          obj.transaction_no = transaction_no;
          obj.transactionat = transactionat;
          obj.inv_file = pi.inv_file;
          obj.inbound = inbound;
          obj.outbond = outbond;
          obj.saldo = saldo;
          obj.pic = pi.inv_createdby?.name;
          arr.push(obj);
        });
      })
      setStockCard(arr);
    }
    else {
      setStockCard([]);
    }
  }, [productInventories]);

  useEffect(() => {
    if (branchSelected) {
      dispatch(resetBrandState());
      dispatch(resetProductInventoryBranchState());
      dispatch(onGetProductInventoryBranches({ branchId: branchSelected.value }));
      dispatch(resetProductVarianState());
      dispatch(getProductVarian({ type: "referral" }));
    }
  }, [branchSelected]);

  useEffect(() => {
    setProductInventoryBranch(productInventoryBranchAdded);
  }, [productInventoryBranchAdded]);

  useEffect(() => {
    if (!isEmpty(productInventoryBranchAdded)) {
      setProductInventoryBranch(productInventoryBranchAdded);
    }
  }, [productInventoryBranchAdded]);

  useEffect(() => {
    if (!isEmpty(productInventoryBranches)) {
      setProductInventoryBranchList(productInventoryBranches.map((el) => ({ ...el, isChecked: false })));
      setInfo(productInventoryBranches[productInventoryBranches.length - 1]);
    }
    else {
      setProductInventoryBranchList([]);
    }
  }, [productInventoryBranches]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "inv_branch_product_name",
        label: "Item",
        isSelected: true,
        data: [],
      },
      {
        id: "inv_branch_varian",
        label: "Barcode",
        isSelected: true,
        data: [],
      },
      {
        id: "inv_branch_product_brand",
        label: "Merek",
        isSelected: true,
        data: [],
      },
      {
        id: "inv_branch_branch",
        label: "Cabang",
        isSelected: true,
        data: [],
      },
      {
        id: "stocks",
        label: "Stok",
        isSelected: true,
        data: [],
      },
      {
        id: "allocated",
        label: "Allocated",
        isSelected: true,
        data: [],
      },
      {
        id: "onhands",
        label: "Onhand",
        isSelected: true,
        data: [],
      },
      {
        id: "inv_branch_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "inv_branch_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (productInventoryBranchList.length > 0) {
      productInventoryBranchList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "inv_branch_product" || doc.id === "inv_branch_branch" || doc.id === "inv_branch_client" || doc.id === "inv_branch_company") {
                doc.data.push(value.name);
              } else if (doc.id === "inv_branch_varian") {
                doc.data.push(value.sku);
              } else if (doc.id === "stocks" || doc.id === "allocated") {
                let qty = parseFloat(value) > 0 ? parseFloat(value) : 0;
                doc.data.push(qty);
              } else if (doc.id === "onhands") {
                let qty = parseFloat(data.allocated) > 0 ? parseFloat(data.stocks) - parseFloat(data.allocated) : parseFloat(data.stocks);
                doc.data.push(qty);
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "inv_branch_product") {
                const nameDoc = dataDoc.find((d) => d.id === "inv_branch_product_name");
                const brandDoc = dataDoc.find((d) => d.id === "inv_branch_product_brand");

                nameDoc.data.push(value.name);
                brandDoc.data.push(value.product_brand?.name ?? "");
              }
            }
          });
        }
      });
    }

    setProductInventoryBranchDoc(dataDoc);
  }, [productInventoryBranchList]);

  useEffect(() => {
    if (companies && !companies.length) {
      dispatch(resetCompanyState());
      dispatch(getCompany());
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  function handleCompanyClick(companyId) {
    setCompanyId(companyId);
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId, status: 2 }));
    dispatch(resetBrandState());
    dispatch(getBrand({ companyId: companyId, status: 2 }));
    return false;
  }

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian_name = item.pvar_product.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options &&
          item.pvar_options.forEach((i, k) => {
            option_name += i.name + "/";
          });

        var obj = { label: varian_name + " " + option_name.slice(0, -1) + " - " + barcode, name: varian_name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId };
        opt.push(obj);
      });
      var option = { options: opt };
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  const handleGetBranch = (companyId) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(brands)) {
      var data = [];
      var opt = [];
      brands.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBrandList(data);
    }
  }, [brands]);

  const [brandId, setBrandId] = useState("all");
  const [branchId, setBranchId] = useState("all");
  const [branchName, setBranchName] = useState("");

  const handleBrandClick = (filter) => {
    let filteredProducts = productInventoryBranches;
    if (filter !== "all") {
      if (branchId === "all") filteredProducts = productInventoryBranches.filter((data) => data.inv_branch_product.product_brand.id === filter);
      else filteredProducts = productInventoryBranches.filter((data) => data.inv_branch_product.product_brand.id === filter && data.branchId === branchId);
    }
    setProductInventoryBranchList(filteredProducts);
    setBrandId(filter);
  };

  const handleBranchClick = (filter) => {
    let filteredProducts = productInventoryBranches;
    if (filter !== "all") {
      if (brandId === "all") filteredProducts = productInventoryBranches.filter((data) => data.branchId === filter);
      else filteredProducts = productInventoryBranches.filter((data) => data.branchId === filter && data.inv_branch_product.product_brand.id === brandId);
    }
    setProductInventoryBranchList(filteredProducts);
    setBranchId(filter);
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setProductInventoryBranch(null);
      setProductInventoryBranchDetailItem([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setProductInventoryBranch(null);
      setProductInventoryBranchDetailItem([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const handleInvoiceClick = (arg) => {
    const productInventoryBranch = arg;

    if (productInventoryBranch.productInventoryBranch_file && productInventoryBranch.productInventoryBranch_file.length) setOriginalFiles(productInventoryBranch.productInventoryBranch_file);
  };

  const handleProductInventoryBranchClick = useCallback(
    (arg) => {
      const productInventoryBranch = arg;
      let productInventoryBranchDetail = [];

      if (productInventoryBranch.productInventoryBranch_file && productInventoryBranch.productInventoryBranch_file.length) setOriginalFiles(productInventoryBranch.productInventoryBranch_file);

      setProductInventoryBranch({
        id: productInventoryBranch.id,
        description: productInventoryBranch.description,
        productInventoryBranch_type: productInventoryBranch.productInventoryBranch_type && { label: productInventoryBranch.productInventoryBranch_type, value: productInventoryBranch.productInventoryBranch_type },
        department: productInventoryBranch.productInventoryBranch_department && { label: productInventoryBranch.productInventoryBranch_department.name, value: productInventoryBranch.productInventoryBranch_department.id },
        branch: productInventoryBranch.inv_branch_branch && { label: productInventoryBranch.inv_branch_branch.name, value: productInventoryBranch.inv_branch_branch.id },
        company: productInventoryBranch.productInventoryBranch_company && productInventoryBranch.productInventoryBranch_company.name && { label: productInventoryBranch.productInventoryBranch_company.name, value: productInventoryBranch.productInventoryBranch_company.id },
        status: productInventoryBranch.productInventoryBranch_status && { label: productInventoryBranch.productInventoryBranch_status.name, value: productInventoryBranch.productInventoryBranch_status.id },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  function currencyFormat(num) {
    return "Rp " + parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = productInventoryBranchList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setProductInventoryBranchList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    filterable: false,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0 ">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = productInventoryBranchList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setProductInventoryBranchList(updatedData);
            }} />
          <Link
            to="#"
            className="btn-icon btn btn-sm btn-light"
            onClick={() => {
              setStockCard([]);
              dispatch(resetProductInventoryState());
              dispatch(onGetProductInventories({ type: "inventory", branchId: branchSelected?.value ?? "", productId: data.productId }));
              toggle();
            }}>
            <i className="ri-eye-line fs-15"></i>
          </Link>
        </div>
      );
    },
  },
  {
    Header: "Item",
    accessor: "inv_branch_product.name",
    filterable: true,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="d-flex align-items-center cursor-pointer"
          onClick={() => {
            setStockCard([]);
            dispatch(resetProductInventoryState());
            dispatch(onGetProductInventories({ type: "inventory", branchId: branchSelected?.value ?? "", productId: data.productId }));
            toggle();
          }}>
          <div className="flex-shrink-0">
            {data.inv_branch_varian && data.inv_branch_varian.pvar_image ? (
              <img src={data.inv_branch_varian.pvar_image === "" ? logo : `${api.MEDIA_URL}/media/${data.inv_branch_varian.pvar_image}`} alt="" className="avatar-xs rounded-circle" />
            ) : (
              <div className="flex-shrink-0 avatar-xs me-2">
                <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{data.inv_branch_product.name.charAt(0)}</div>
              </div>
            )}
          </div>
          <div className="flex-grow-1 ms-2 name">{data.inv_branch_product.name && data.inv_branch_product.name}</div>
        </div>);
    },
  },
  {
    Header: "Barcode",
    accessor: "inv_branch_varian.sku",
    filterable: true,
  },
  {
    Header: "Merek",
    accessor: "inv_branch_product.product_brand.name",
    filterable: true,
  },
  {
    Header: "Cabang",
    accessor: "inv_branch_branch.name",
    filterable: true,
  },
  {
    Header: "Stok",
    accessor: "stocks",
    filterable: true,
    Cell: (data) => {
      let qty = parseFloat(data.value) > 0 ? parseFloat(data.value) : 0;
      return <span className="fw-semibold text-muted">{qty}</span>;
    },
  },
  {
    Header: "Allocated",
    accessor: "allocated",
    filterable: true,
    Cell: (data) => {
      let qty = parseFloat(data.value) > 0 ? parseFloat(data.value) : 0;
      return <span className="fw-semibold text-muted">{qty}</span>;
    },
  },
  {
    Header: "Onhand",
    accessor: (data) => (parseFloat(data.allocated) > 0 ? parseFloat(data.stocks) - parseFloat(data.allocated) : parseFloat(data.stocks)),
    filterable: true,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      let qty = parseFloat(data.allocated) > 0 ? parseFloat(data.stocks) - parseFloat(data.allocated) : parseFloat(data.stocks);
      return <span className="fw-semibold">{qty}</span>;
    },
  },
  ],
    [productInventoryBranchList, handleProductInventoryBranchClick, userRole, userType, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = productInventoryBranchList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setProductInventoryBranchList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => productInventoryBranchList, [productInventoryBranchList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: productInventoryBranchList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusProductInventoryBranch.value ? statusProductInventoryBranch.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      branchId: branchSelected?.value,
      type: "inbound-product",
    };
    dispatch(onGetProductInventoryBranches(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setSearchValue("");
    onGetProductInventoryBranches({ branchId: branchSelected?.value });
  }

  document.title = "Persediaan Barang | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={productInventoryBranchList} />
      <Container fluid>
        <BreadCrumb title="Persediaan" pageTitle="Persediaan Barang" loading={loading || productInventoryLoading}>
          <div className="flex-shrink-0">
            <ExportDoc data={productInventoryBranchDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                placeholder={`${countSearch} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                value={filterDate}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={1}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}>
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    MUTASI KARTU GUDANG
                  </ModalHeader>
                  <ModalBody>
                    <CardBody className="border-top border-top-dashed">
                      <SimpleBar style={{ height: "520px" }}>
                        <Table className="table-border text-center table-nowrap align-middle mb-0" style={{ position: "relative" }}>
                          <thead className="align-middle" style={{ position: "sticky", top: "0px", zIndex: "1", backgroundColor: "#FFFFFF" }}>
                            <tr className="bg-soft-info">
                              <td style={{ width: "20px" }}>
                                <input
                                  type="checkbox"
                                  className="checkboxDetailAll me-2 form-check-input"
                                  checked={stockCard.every((item) => item.isChecked)}
                                  onChange={() => {
                                    const allChecked = stockCard.every((item) => item.isChecked);
                                    const updatedData = stockCard.map((item) => {
                                      return {
                                        ...item,
                                        isChecked: !allChecked,
                                      };
                                    });
                                    setStockCard(updatedData);
                                  }}
                                />
                              </td>
                              <td className="text-start">Produk</td>
                              <td className="text-center" style={{ width: "100px" }}>
                                Tanggal
                              </td>
                              <td>PIC</td>
                              <td>Jenis</td>
                              <td className="text-center" style={{ width: "120px" }}>
                                No Transaksi
                              </td>
                              <td className="text-center">Status</td>
                              <td className="text-center" style={{ width: "100px" }}>
                                Inbound
                              </td>
                              <td className="text-center" style={{ width: "100px" }}>
                                Outbound
                              </td>
                              <td className="text-center" style={{ width: "100px" }}>
                                Saldo Stok
                              </td>
                              <td className="text-center">Keterangan</td>
                            </tr>
                            <tr className="bg-light border-bottom">
                              <th></th>
                              <th className="text-start text-info" colSpan={6}>
                                TOTAL
                              </th>
                              <th className="text-info">{(stockCard || []).reduce((a, v) => (a = a + parseFloat(v.inbound || 0)), 0).toFixed(2)}</th>
                              <th className="text-info">{(stockCard || []).reduce((a, v) => (a = a + parseFloat(v.outbond || 0)), 0).toFixed(2)}</th>
                              <th className="text-info">{(stockCard || []).reduce((a, v) => (v.transaction_status === "IN" ? a = a + parseFloat(v.quantity || 0) : a = a - parseFloat(v.quantity || 0)), 0).toFixed(2)}</th>
                              <th className="text-info"></th>
                            </tr>
                          </thead>
                          <tbody id="newlink">
                            {(stockCard || [])
                              .map((o, i) => {
                                let status = "";
                                switch (o.transaction_status) {
                                  case "IN":
                                    status = <span className="badge text-uppercase badge-soft-success me-2">{o.transaction_status}</span>;
                                    break;
                                  case "OUT":
                                    status = <span className="badge text-uppercase badge-soft-danger me-2">{o.transaction_status}</span>;
                                    break;
                                  default:
                                    status = <span className="badge text-uppercase badge-soft-warning me-2">{o.transaction_status}</span>;
                                    break;
                                }

                                return <Fragment key={i}>
                                  <tr className="product bg-light">
                                    <td className="product-id">
                                      <input
                                        type="checkbox"
                                        className={o.transaction_no && o.transaction_no !== "" ? "checkboxDetail ms-2 me-2 form-check-input" : "d-none"}
                                        checked={o.isChecked}
                                        onChange={() => {
                                          const updatedData = stockCard.map((d) => {
                                            return d.id === o.id ? { ...d, isChecked: !d.isChecked } : d;
                                          });

                                          setStockCard(updatedData);
                                        }}
                                      />
                                    </td>
                                    <td className="text-start fw-semibold">{o?.inv_product?.name}</td>
                                    <td className="text-center">{handleValidDate(o.transactionat)}</td>
                                    <td className="text-center">{o.pic}</td>
                                    <td className="text-center">{o.type}</td>
                                    <td className="text-center">{o?.transaction_no}</td>
                                    <td className="text-center fw-semibold">
                                      {status}
                                      {o?.inv_transfer && <span className={o?.inv_transfer?.type === "Production" ? "badge text-uppercase badge-soft-warning" : "badge text-uppercase badge-soft-primary"}> {o?.inv_transfer?.type}</span>}
                                      {o?.inv_purchase && <span className="badge text-uppercase badge-soft-info"> Pembelian</span>}
                                    </td>
                                    <td className={"text-center fw-semibold"}>{o.inbound}</td>
                                    <td className={"text-center fw-semibold"}>{o.outbond}</td>
                                    <td className={"text-center fw-semibold"}>{o.saldo.toFixed(2)}</td>
                                    <td className="text-start">{o.description}</td>
                                  </tr>
                                  {(o.inv_file || []).length > 0 && (
                                    <tr>
                                      <td></td>
                                      <td colSpan={10} className="pe-0">
                                        <Accordion className="p-0 w-100 border-0 lefticon-accordion accordion-primary custom-accordionwithicon">
                                          {(o.inv_file || []).length > 0 && (
                                            <AccordionItem className="border-0">
                                              <div
                                                className={classnames("accordion-button p-0 m-0 ps-4 fs-13", { collapsed: activeAccordion === i + 10000 ? false : true })}
                                                onClick={() => {
                                                  toggleActiveAccordion(i + 10000);
                                                }}
                                                style={{ cursor: "pointer" }}
                                              >
                                                <div className="p-2 text-info fw-semibold" style={{ width: "100%" }}>
                                                  Bukti Transaksi
                                                </div>
                                              </div>
                                              <Collapse isOpen={activeAccordion === i + 10000 ? true : false} className="accordion-collapse bg-light border-0">
                                                <div className="accordion-body p-0 ps-4 pe-0 fw-normal fs-12 text-dark">
                                                  {(o.inv_file || []).map((f, ii) => {
                                                    let type;
                                                    return (
                                                      <div className="px-2 py-2 text-start border-bottom" key={ii}>
                                                        {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                                          <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                                        ) : (
                                                          <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                            <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                                          </Link>
                                                        )}
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              </Collapse>
                                            </AccordionItem>
                                          )}
                                        </Accordion>
                                      </td>
                                    </tr>
                                  )}
                                </Fragment>


                              })}
                            {stockCard.length === 0 && (
                              <tr>
                                <td colSpan="11" className="p-3 text-center">
                                  Belum ada data
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </SimpleBar>
                    </CardBody>


                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={() => {
                          setModal(false);
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductInventoryBranch;
